import React from 'react'

export default function Main() {
  return <div>Main</div>
}
